import { useState } from 'react';

export function useMultiSelect<T>(
  items: T[],
  getId: (item: T) => string
) {
  const [selectedIds, setSelectedIds] = useState<string[]>([]);
  const [lastSelectedIndex, setLastSelectedIndex] = useState<number | null>(null);

  const handleRowSelection = (
    event: React.MouseEvent,
    id: string,
    index: number
  ) => {
    if (event.shiftKey && lastSelectedIndex !== null) {
      const start = Math.min(lastSelectedIndex, index);
      const end = Math.max(lastSelectedIndex, index);

      const rangeIds = items.slice(start, end + 1).map(getId);

      setSelectedIds((current) => [...new Set([...current, ...rangeIds])]);
      return;
    }

    setSelectedIds((current) =>
      current.includes(id)
        ? current.filter((x) => x !== id)
        : [...current, id]
    );

    setLastSelectedIndex(index);
  };

  const toggleAll = (checked: boolean) => {
    setSelectedIds(checked ? items.map(getId) : []);
  };

  return {
    selectedIds,
    setSelectedIds,
    allSelected:
      items.length > 0 &&
      items.every((item) => selectedIds.includes(getId(item))),
    isSelected: (id: string) => selectedIds.includes(id),
    handleRowSelection,
    toggleAll,
  };
}